import { Alert, type AlertProps, type GetRef } from 'antd';
import type { Ref } from 'react';

export interface BaseAlertProps extends AlertProps {
  ref?: Ref<GetRef<typeof Alert>>;
}

/** 行内反馈统一展示语义图标，保留原生类型、关闭与操作区域。 */
export default function BaseAlert({
  showIcon = true,
  className,
  ...props
}: BaseAlertProps) {
  return (
    <Alert
      {...props}
      showIcon={showIcon}
      className={['base-alert min-w-0', className].filter(Boolean).join(' ')}
    />
  );
}
